import React from 'react';

const DeleteForm: React.FC = () => {
  return (
    <div className="delete-form-container flex flex-col items-center justify-center pb-10 bg-dark-blue rounded-lg shadow-md max-w-lg mx-auto">
<h1 className="text-4xl text-center text-gray-300 mb-4 mt-4">Features</h1>
      <p className="text-xl text-center text-gray-400 mb-6">
        Explore all the available features in Deck Hopper.
      </p>
      <hr className="border-t border-gray-600 w-2/3 mb-8" />
      <p className="mb-6 font-bold">Use this form to request deletion of your Deck Hopper account and associated data.</p>
      <p className="mb-6">Please include your User ID and explicitly state your request to delete your account. Upon deletion, all data associated with your account will be permanently removed.</p>

      <form action="https://api.staticforms.xyz/submit" method="post" className="w-full">
        <input type="hidden" name="accessKey" value="724e2b70-92b6-44ff-ae60-2d70b1d8c29f" />

        <div className="mb-4">
          <label htmlFor="email" className="block font-bold mb-2">Email:</label>
          <input type="email" id="email" name="email" placeholder="Your Email" required className="text-black shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" />
        </div>

        <div className="mb-4">
          <label htmlFor="account-id" className="block font-bold mb-2">Account ID:</label>
          <p className="text-sm">Find your Account ID in Deck Hopper under Menu - Account tab - Get User ID.</p>
          <input type="text" id="account-id" name="$accountID" placeholder="Your Account ID" required className="mt-2 text-black shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" />
        </div>

        <div className="mb-4">
          <label htmlFor="deletion-request" className="block font-bold mb-2">Deletion Request:</label>
          <textarea id="deletion-request" name="$deletionRequest" placeholder="I request the deletion of my account and all associated data." required className="mt-2 text-black shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"></textarea>
        </div>

        <input type="text" name="honeypot" style={{ display: 'none' }} />
        <input type="hidden" name="replyTo" value="@" />
        <input type="hidden" name="redirectTo" value="https://christinak.ca/deckhopper/datadeletion?form=success" />

        <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-gray-300 font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">Request Deletion</button>
      </form>
    </div>
  );
};

export default DeleteForm;
